<template>
    <div style="height: 100%; overflow-y: hidden">
        <van-cell-group>
            <van-field
                    v-model="formData.nameOrPhone"
                    label="用户名"
                    placeholder="请输入手机号/用户名"
            />
            <van-field
                    type="password"
                    v-model="formData.password"
                    label="密码"
                    placeholder="请输入密码"
            />
        </van-cell-group>
        <div style="padding: 20px;">
            <van-button type="danger" round size="large"  @click.stop="save">登录</van-button>
        </div>
        <div style="padding: 10px">
            <p class="fl link" v-rblink.replace="{name:'regist'}">注册新账号</p>
            <p class="link fr" v-rblink.replace="{name:'loginBySms'}">短信快捷登录</p>
        </div>
        <div class="cert-status login-success" :style="{top:success?'0px':'1000px'}">
            <div class="cert-status-content">
                <div class="cert-status-icon-success"></div>
                <p class="cert-status-title">{{phone}}</p>
                <p class="cert-status-title">登陆成功</p>
            </div>
        </div>
    </div>
</template>

<style scoped="">
</style>
<script>
    import {
        Cell, CellGroup,NoticeBar,Field,Button
    } from 'vant';
    export default {
        name: 'loginByUsername',
        components: {
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [NoticeBar.name]: NoticeBar,
            [Button.name]: Button,
        },
        data: function () {
            return {
                formData:{
                    nameOrPhone:'',
                    password:'',
                },
                phone:'',
                success: false,
                fileList:[]
            }
        },
        mounted: function () {
            document.title = "用户登录";
        },
        methods: {
            save(){
                var that = this;
                this.$api.get("/api/index/login", that.formData, r => {
                    // that.$toast.fail('成功');
                    localStorage.setItem('_pspt',r.data.token);
                    that.phone =  r.data.phone.substring(0,3)+'****'+r.data.phone.substring(7) ;
                    that.success = true;
                    appEvent({
                        name: 'login',
                        query: {
                            token:r.data.token,
                            phone:r.data.phone,
                        }
                    });
                    if(r.data.idCheck == false){
                        setTimeout(function(){
                            rbLink({
                                'name':'profileTodo'
                            },'replace');
                        },1000);
                    }else{
                        setTimeout(function(){
                            rbLink({
                                'name':''
                            },'back');
                        },1000);
                    }
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// loginByUsername.vue?a9f65ec2